@let view = data();
@let image = view.image;
@let link = view.link?.href ? view.link : undefined;
@let caption = view.type === 'galleryImage' && image.type === 'image' ? image.caption : undefined;

@if (link) {
  <a uiPageBlockLinkClick uiContentLink [link]="link">
    <ng-container *ngTemplateOutlet="tplImage"></ng-container>
  </a>
} @else {
  <ng-container *ngTemplateOutlet="tplImage"></ng-container>
}

<ng-template #tplImage>
  <ui-image [data]="image"></ui-image>
  @if (caption) {
    <p class="caption">{{ caption }}</p>
  }
</ng-template>
